import { Injectable, inject } from "@angular/core";
import { BehaviorSubject, throwError } from "rxjs";
import {AbstractControl, ValidatorFn} from "@angular/forms";
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
  })
  export class BaseService {

  public API_BASE_URL = environment?.apiBaseUrl;
  public API_BASE_URLv4 = environment?.apiBaseUrlV4;

  public OTC_BASE_URL = environment?.otcBaseUrl;

  public API_ADMIN_BASE_URL = environment.apiAdminBaseUrl;

  public hasError = new BehaviorSubject<boolean>(false);
    hasError$ = this.hasError.asObservable();

    public errorMessage = new BehaviorSubject<string>("");
    errorMessage$ = this.errorMessage.asObservable();

    errorHandler(error) {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
      } else {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      return throwError(errorMessage);
    }

  matchValidator(controlName: string, matchingControlName: string): ValidatorFn {
    return (abstractControl: AbstractControl) => {
      const control = abstractControl.get(controlName);
      const matchingControl = abstractControl.get(matchingControlName);

      if (matchingControl!.errors && !matchingControl!.errors?.['confirmedValidator']) {
        return null;
      }

      if (control!.value !== matchingControl!.value) {
        const error = {confirmedValidator: 'Passwords do not match.'};
        matchingControl!.setErrors(error);
        return error;
      } else {
        matchingControl!.setErrors(null);
        return null;
      }
    }
  }

    ////////////////////////////////////////////////////////////////////////////
    //////////////////                GET                     //////////////////
    ////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////
    ////////////////////             INSERT                  ///////////////////
    ////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////
    ////////////////////             UPDATE                  ///////////////////
    ////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////
    ////////////////////             DELETE                  ///////////////////
    ////////////////////////////////////////////////////////////////////////////
    
  }  
